import cookie from 'react-cookie';
import WorthyApi from 'lib/api/worthyApi';
import rootStore        from 'reducers';
import {LAST_SUBMIT_LS_KEY} from 'actions/pendingItem';
import {createJewelryBox} from './jewelryBox';
import { ItemTypes } from '../constants/itemDetails'
import { LS } from '../helpers/ApplicationHelper'
import { getItemsCount } from './itemsCount'

export const NEW_JEWELRY_BOX_PENDING = Symbol('NEW_JEWELRY_BOX_PENDING');
export const CREATE_JEWELRY_BOX_PENDING = Symbol('CREATE_JEWELRY_BOX_PENDING');
export const GET_JEWELRY_BOX_USER_DATA = Symbol('GET_JEWELRY_BOX_USER_DATA');

export function createPendingJewelryBox(subsets, isLoggedIn) {
    LS.set(LAST_SUBMIT_LS_KEY, {itemType: ItemTypes.JewelryBox, subsets})
    rootStore.dispatch(createJewelryBox(subsets)).then((res) => {
        cookie.remove(`${__ENV__}_pending_jewelry_box`, {path: '/', domain: 'worthy.com'});

        if (isLoggedIn) {
            window.location.pathname = `/multiple_jewelry/${res.payload.data.bundle_id}`;
            rootStore.dispatch(getItemsCount(res.payload.data.user.id))
        }
        return res;
    });
    return {
        payload: isLoggedIn ? null : Object.assign({}, {subsets}),
        type: isLoggedIn ? CREATE_JEWELRY_BOX_PENDING : NEW_JEWELRY_BOX_PENDING
    }
}

export function getPendingJewelryBoxFromCookie() {
    let pendingJewelryBoxCookie = cookie.load(`${__ENV__}_pending_jewelry_box`);

    if (pendingJewelryBoxCookie && typeof(pendingJewelryBoxCookie)=='object' && Object.keys(pendingJewelryBoxCookie).includes('subsets')) {
        return pendingJewelryBoxCookie;
    }
}

export function getJewelryBoxUserData(bundleId) {
    const request = WorthyApi.getJewelryBoxUserData(bundleId);
    return {
        type: GET_JEWELRY_BOX_USER_DATA,
        payload: request
    }
}
